import { render, staticRenderFns } from "./itemDialogSms.vue?vue&type=template&id=3046361f&scoped=true&"
import script from "./itemDialogSms.vue?vue&type=script&lang=js&"
export * from "./itemDialogSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3046361f",
  null
  
)

export default component.exports